import { gql } from '@apollo/client';
import { SHARED_ACADEMIC_FIELDS } from './queries';

export const UPDATE_ACADEMIC_DETAILS = gql`
  mutation updateAcademicUser($input: UpdateAcademicUserInput!) {
    result: updateAcademicUser(input: $input) {
      result {
        ${SHARED_ACADEMIC_FIELDS}
      }
    }
  }
`;
